/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Auction } from '../../models/auction';
import { NewAuction } from '../../models/new-auction';

export interface EditorCreateAuction$Params {
      body?: NewAuction
}

export function editorCreateAuction(http: HttpClient, rootUrl: string, params?: EditorCreateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<Auction>> {
  const rb = new RequestBuilder(rootUrl, editorCreateAuction.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Auction>;
    })
  );
}

editorCreateAuction.PATH = '/editor/auctions';
